module.exports = __webpack_public_path__ + "static/media/shopicon.cae01c7b.svg";